module.exports = __webpack_public_path__ + "img/T160多功能水面无人船.7741ada2.png";